import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify, {
  theme: {
    primary: "#902923",
    secondary: "#03A9F4",
    accent: "#EC9A29",
    error: "#B71C1C",
    warning: "#ffeb3b",
    info: "#2196f3",
    success: "#8BC34A"
  }
});
